<footer class="app-footer">
  <nav class="container-fluid" [attr.aria-label]="'footer_menu' | translate" [class.text-light]="useTextLight$ | async">
    <span class="footer-text">
      © {{ footerTitle }},
      <span title="{{ 'application_publish_date' | translate: appVersion.publishDate }}">
        {{ 'application_version' | translate: appVersion.version }}
      </span>
    </span>
    <span aria-hidden="true">|</span>
    <a href="https://www.levelaccess.com/terms-service" target="_blank">{{ 'terms_of_use' | translate }}</a>
    <span aria-hidden="true">|</span>
    <a href="https://www.levelaccess.com/privacy-policy" target="_blank">{{ 'privacy_policy' | translate }}</a>
    <span aria-hidden="true">|</span>
    <a [routerLink]="['/', Api.cookie_policy]" [target]="linkTarget" [rel]="linkRel" data-test-id="footer-cookie-policy-link">{{
      'cookie_policy' | translate
    }}</a>
    @if (showAttributionLink$ | async) {
      <span aria-hidden="true">|</span>
      <a [routerLink]="['/', Api.attribution]" [target]="linkTarget" [rel]="linkRel" data-test-id="footer-attribution-link">{{
        'attribution_label' | translate
      }}</a>
    }
  </nav>

  @if (cookieMessageClosed === false) {
    <ds-banner
      class="cookies-message"
      [state]="DsBannerState.info"
      [showTitle]="false"
      [showAction]="true"
      [showCloseButton]="false"
      bannerAriaRole="status"
    >
      <div ds-banner-body>
        <span class="visuallyhidden">{{ 'cookies_disclaimer' | translate }}</span>
        <span [innerHTML]="'cookie_usage_message' | translateHtml: '/cookie-policy'"></span>
      </div>

      <ng-container ds-banner-action>
        <button
          ds-button
          [variant]="actionButtonVariant.primary"
          [intent]="actionButtonIntent.default"
          [hideIcon]="true"
          (click)="removeCookiesUsageMessage()"
        >
          {{ 'accept' | translate }}
        </button>
      </ng-container>
    </ds-banner>
  }
</footer>
